export default "/_next/static/sounds/sounds_of_rose-5dacfca23cecdf208b6f409e6b80a587.mp3";